import React from "react";
import { Button, Flex } from "@radix-ui/themes";
import * as Tooltip from "@radix-ui/react-tooltip";
import { QuestionMarkCircledIcon } from "@radix-ui/react-icons";

import { SimulatorChannel } from "@/api/simulator/simulator.model";
import { RegressionTestsEmbeddable } from "@/routes/regression-tests/embeddable";
import { useFlag } from "@/v2/components/feature-flag/FeatureFlagContext";

import styles from "./styles.module.scss";

interface ReleaseActionsProps {
  onRelease: () => void;
  coverage: string;
  disabled?: boolean;
  isReleasing?: boolean;
  channel?: SimulatorChannel;
  releaseId: number;
  simulatorId: number;
}

export const ReleaseActions: React.FC<ReleaseActionsProps> = ({
  onRelease,
  coverage,
  disabled = false,
  isReleasing = false,
  channel,
  releaseId,
  simulatorId,
}) => {
  return (
    <Tooltip.Provider delayDuration={0}>
      <div className={styles.releaseActionsContainer}>
        <div className={styles.releaseActionsContent}>
          <Flex justify="end" align="center" className="gap-4">
            {channel === "autonomous_ticket_event" && (
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <div className={styles.coverageInfo}>
                    <span>Est. Coverage {coverage}</span>
                    <QuestionMarkCircledIcon className={styles.helpIcon} />
                  </div>
                </Tooltip.Trigger>
                <Tooltip.Content
                  className={styles.tooltipContent}
                  sideOffset={5}
                >
                  This is an estimation based on the configuration from 100 most
                  recent tickets
                  <Tooltip.Arrow className={styles.tooltipArrow} />
                </Tooltip.Content>
              </Tooltip.Root>
            )}
            <RegressionTestsEmbeddable
              releaseId={releaseId ?? 0}
              simulatorId={simulatorId ?? 0}
            />

            <Button
              className={`${styles.releaseButton} ${
                isReleasing ? styles.releasingButton : ""
              }`}
              onClick={onRelease}
              disabled={disabled || isReleasing}
            >
              {isReleasing ? (
                <Flex align="center" gap="2">
                  <div className={styles.releasingSpinner} />
                  <span>Releasing...</span>
                </Flex>
              ) : disabled ? (
                <Flex align="center" gap="2">
                  <div className={styles.loadingSpinner} />
                  <span>Saving changes...</span>
                </Flex>
              ) : (
                "Release"
              )}
            </Button>
          </Flex>
        </div>
      </div>
    </Tooltip.Provider>
  );
};
